import React from 'react'
import { ConsentStatsType } from 'types/consentStats.types'
import consent from 'constants/consent'

export type StatsCardConfig = {
  key: keyof ConsentStatsType
  icon: React.ComponentType<{ size?: number }>
  label: string
  backgroundColor: string
}

export type ProcessedStatsCard = {
  icon: React.ReactElement
  label: string
  value: number
  backgroundColor: string
}

export const getConsentStatsCards = (
  stats?: ConsentStatsType
): ProcessedStatsCard[] => {
  return consent.CONSENT_STATS_CARDS.map((config) => {
    const IconComponent = config.icon
    return {
      icon: React.createElement(IconComponent, { size: 20 }),
      label: config.label,
      value: stats?.[config.key] || 0,
      backgroundColor: config.backgroundColor,
    }
  })
}

export default {
  getConsentStatsCards,
}
